import { AbTastyJsApi } from '@abtasty/tag-api-types';

import { getCookie } from '@src/helpers/cookies/getCookie';
import { SerializedABTasty, TagData } from '@src/application/modules/tag/shared/tag/serializedTagTypes';

const tagJsApiErrors: string[] = [];
const getFromTagJsApi = (
  api: AbTastyJsApi.Api,
  keys: AbTastyJsApi.ApiKey[],
  fallbackValue: boolean,
  callback?: () => void
): AbTastyJsApi.ApiValue | boolean => {
  try {
    const args = callback ? [...keys, callback] : keys;
    return api.v1.getValue(...args) as AbTastyJsApi.ApiValue;
  } catch (e) {
    // Bypass Tag error if key is unknown
    const errorText = (e as Error).toString();

    // Display only one time the same error per page
    if (!tagJsApiErrors.includes(errorText)) {
      tagJsApiErrors.push(errorText);

      console.warn('Use fallback value as Tag JS API throw an error:', errorText);
    }

    return fallbackValue;
  }
};

export const serializeTagData = async (refreshTagData: () => void): Promise<TagData | null> => {
  const tag = window.ABTasty;
  const ABTastyCookie = (getCookie('ABTasty') || localStorage.getItem('ABTasty')) as string;
  const ABTastySessionCookie = (getCookie('ABTastySession') || localStorage.getItem('ABTastySession')) as string;
  if (tag) {
    const serializedTag: SerializedABTasty = JSON.parse(JSON.stringify(window.ABTasty));
    const localStorageABTastyData = window.localStorage.getItem('ABTastyData');
    const sessionsStorageABTastyUA = window.sessionStorage.getItem('ABTastyUA');
    const parsedUserAgent = await tag.getParsedUserAgentAsync();

    return {
      urlHistory: { current: window.location.href, previous: document.referrer },
      ...serializedTag,
      testsOnPage: tag.getTestsOnPage(),
      geoloc: tag.getGeoloc(),
      parsedUserAgent,
      ABTastyCookie,
      ABTastySessionCookie,
      ABTastyData: localStorageABTastyData ? JSON.parse(localStorageABTastyData) : null,
      ABTastyUA: sessionsStorageABTastyUA ? JSON.parse(sessionsStorageABTastyUA) : null,
      browserLanguage: window.navigator.language,
      screenSize: window.innerWidth,
      hasRefreshedJsCache: getFromTagJsApi(
        tag.api,
        ['general', 'jsCacheRefreshed'],
        false,
        refreshTagData
      ) as AbTastyJsApi.General['jsCacheRefreshed'],
    };
  }
  return null;
};
